import { createSlice } from '@reduxjs/toolkit'
import { fetchDailyStatisticsReport, fetchDashboardReport } from 'redux-thunk/thunk/Dashboard/dashboard'

const initialState = {
  loading: false,
  report: null,
  dailyStatistics: {}
}

const gameReportsSlice = createSlice({
  name: 'dashboardSlice',
  initialState,
  reducers: {
    updateDashboardReport: (state, action) => {
      const report = action.payload && typeof action.payload === 'object'
        ? action.payload
        : state.report
      return {
        ...state,
        report
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardReport.pending, (state, action) => {
        return {
          ...state,
          loading: true
        }
      })
      .addCase(fetchDashboardReport.fulfilled, (state, action) => {
        const report = action.payload && typeof action.payload === 'object'
          ? action.payload
          : {}
        return {
          ...state,
          loading: false,
          report
        }
      })
      .addCase(fetchDashboardReport.rejected, (state, action) => {
        return {
          ...state,
          loading: false
        }
      })
      .addCase(fetchDailyStatisticsReport.pending, (state, action) => {
        return {
          ...state,
          loading: true
        }
      })
      .addCase(fetchDailyStatisticsReport.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          dailyStatistics: action.payload
        }
      })
      .addCase(fetchDailyStatisticsReport.rejected, (state, action) => {
        return {
          ...state,
          loading: false
        }
      })
  }
})

export const { updateDashboardReport } = gameReportsSlice.actions

export default gameReportsSlice.reducer
